module.exports = __webpack_public_path__ + "img/s2.3c005600.png";